import React, { useEffect, useState } from 'react';
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate';
import { ColumnRollingReserve, RollingReserveData } from '../../../types/TablesTypes/rollingReserve';
import client from '../../../api/client';
import showToast from '../../../components/CustomToast/toastHelper';
import StatusView from '../../../components/StatusView/StatusView';
import moment, { Moment } from 'moment';
import { numberWithCommas } from '../../../utils/formatNumber';
import { Dropdown } from 'flowbite-react';
import { FaEllipsisH } from 'react-icons/fa';
import { useCurrency } from '../../../contexts/CurrencyContext';

const RollingReserve = () => {
    const {currency} = useCurrency()
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        currency: currency
    });

    const [rollingReserves, setRollingReserves] = useState<any>(null);
    const [tableRow, setTableRow] = useState<RollingReserveData[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(true);
    const [isExport, setIsExport] = useState<boolean>(false)
    const [isExportReady, setIsExportReady] = useState<boolean>(false); 
    const [isExportLoading, setIsExportLoading] = useState<boolean>(false);


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            await fetchRollingReserves();
            setLoading(false)
        };
        fetchData();
    }, [filters, currentPage]);

    const fetchRollingReserves = async () => {
        try {
            const apiUrl = '/subsidiary/dashboard/rolling/reserves';
            const params = new URLSearchParams({
                ...filters,
                page: currentPage.toString(),
            }).toString();
            const response = await client.get(`${apiUrl}?${params}`);

            setRollingReserves(response.data.data);
            setTotalPages(response.data.data.page.totalPage);
            setTableRow(dataProducts());
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('Error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const clickExport = async () => {
        setIsExport(true);
        setIsExportLoading(true)
        await fetchRollingReserves(); 
    
        if (rollingReserves&& rollingReserves.items?.length > 0) {
            setIsExportReady(true); 
        }
    
        setIsExportLoading(false); 
    };

    const dataProducts = () => {
        const tempArr: RollingReserveData[] = [];
        rollingReserves?.items?.forEach((balance: any) => {
            tempArr.push({
                settlementDate: (moment.utc(balance?.settlementDate).local() as Moment).format('MMMM Do YYYY, h:mm a'),
                dueDate: (moment.utc(balance?.dueDate).local() as Moment).format('MMMM Do YYYY, h:mm a'),
                settlementAmount: `${balance?.currency} ${numberWithCommas(balance?.settlementAmount)}`,
                initialAmount: `${balance?.currency} ${numberWithCommas(balance?.settlementAmount - balance?.withheldAmount)}`,
                withheldAmount: `${balance?.currency} ${numberWithCommas(balance?.withheldAmount)}`,
                id: balance?.id,
                status: (
                    <StatusView
                        status={balance?.status}
                        green='Completed'
                        red='Due'
                        indigo="Not due"
                    />
                ),
                balance: `${balance?.currency} ${numberWithCommas(balance?.balance)}`,
                action: (
                    <Dropdown label={<FaEllipsisH />} inline arrowIcon={false} placement='right-start'>
                        {/* Add Dropdown items here */}
                    </Dropdown>
                ),
            });
        });
        return tempArr;
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    useEffect(()=>{
        setTableRow(dataProducts())
    },[rollingReserves?.items])

    return (
        <div>
            <DashboardPagesTemplate
                title='Rolling Reserve'
                onFilterChange={setFilters}
                dataToExport={isExportReady ? rollingReserves?.items : []}
                apiUrl='/subsidiary/dashboard/rolling/reserves'
                ctaButtonExists={false}
                exportButtonExists={true}
                dropdownItems={["All","Debit", "Credit"]}
                data={tableRow}
                showSearch={false}
                buttonIcon=''
                buttonLabel=''
                headings={ColumnRollingReserve}
                filters={filters}
                emptyMessage={`You currently do not have any rolling reserves in ${currency}`}
                loading={loading}
                statusKey='direction'
                clickExportButton={clickExport}
                exportButtonLoading={isExportLoading}
                exportButtonClicked={isExport}
                // onPageChange={handlePageChange} // Ensure this function is used if DashboardPagesTemplate handles page changes
            />
        </div>
    );
};

export default RollingReserve;
